/** 详情页裁剪结果内存缓存：接口尚未返回或同步乱序时，已裁完的图片仍能展示 */

const taskCaches = new Map();

function getTaskCache(taskId) {
  const key = String(taskId || '');
  if (!key) return new Map();
  if (!taskCaches.has(key)) taskCaches.set(key, new Map());
  return taskCaches.get(key);
}

export function rememberImageCropResult(taskId, imageId, patch) {
  if (!taskId || imageId == null || !patch) return;
  const url = patch.croppedUrl ?? patch.croppedImageUrl;
  if (!url || !String(url).trim()) return;
  const displayUrl = patch.croppedDisplayUrl ?? patch.croppedImageUrlDisplay ?? '';
  const original = patch.originalUrl ?? patch.originalImageUrl;
  if (original != null && !String(original).trim()) return;
  getTaskCache(taskId).set(String(imageId), {
    croppedUrl: String(url).trim(),
    croppedDisplayUrl: displayUrl ? String(displayUrl).trim() : '',
    originalUrl: original ? String(original).trim() : '',
    status: patch.status === 'failed' ? 'failed' : 'success',
    error: patch.error ?? null,
    cropPosition: patch.cropPosition ?? null,
    resultRevision: patch.resultRevision ?? null,
  });
}

export function getImageCropResultFromCache(taskId, imageId) {
  return getTaskCache(taskId).get(String(imageId)) || null;
}

/** 列表预览：从内存缓存取任意一张已裁完图的 URL */
export function getFirstCropPreviewFromCache(...taskIds) {
  for (const taskId of taskIds) {
    const key = String(taskId || '').trim();
    if (!key) continue;
    const cache = taskCaches.get(key);
    if (!cache?.size) continue;
    for (const val of cache.values()) {
      const url = val?.croppedUrl && String(val.croppedUrl).trim();
      if (url) return url;
    }
  }
  return '';
}

export function clearImageCropResultCache(taskId) {
  if (taskId != null) taskCaches.delete(String(taskId));
}

export function forgetImageCropResult(taskId, imageId) {
  if (taskId == null || imageId == null) return;
  getTaskCache(taskId).delete(String(imageId));
}

/** 用缓存补全行（展示层与 merge 共用） */
export function applyImageCropResultCache(taskId, rows = []) {
  const cache = getTaskCache(taskId);
  if (!cache.size) return rows;
  return (rows || []).map((row) => {
    const cached = cache.get(String(row.imageId));
    if (!cached?.croppedUrl) return row;
    const originalUrl = String(row.originalUrl || cached.originalUrl || '').trim();
    if (!originalUrl) return row;
    const rowRevision = Number(row.resultRevision) || 0;
    const cacheRevision = Number(cached.resultRevision) || 0;
    if (row.status === 'processing' && cached.status === 'success' && cacheRevision >= rowRevision) {
      return {
        ...row,
        originalUrl: row.originalUrl || cached.originalUrl || '',
        croppedUrl: cached.croppedUrl,
        croppedDisplayUrl: cached.croppedDisplayUrl || cached.croppedUrl,
        status: 'success',
        error: cached.error ?? row.error,
        cropPosition: cached.cropPosition ?? row.cropPosition,
        resultRevision: cached.resultRevision ?? row.resultRevision,
      };
    }
    if (row.status === 'pending' && !row.croppedUrl) return row;
    if (rowRevision > cacheRevision) return row;
    const hasLocal = row.croppedUrl && String(row.croppedUrl).trim();
    if (hasLocal && row.status === 'success') {
      if (Array.isArray(row.cropPosition?.prints) && row.cropPosition.prints.length > 0) {
        return row;
      }
      if (!row.croppedDisplayUrl && cached.croppedDisplayUrl) {
        return { ...row, croppedDisplayUrl: cached.croppedDisplayUrl };
      }
      return row;
    }
    return {
      ...row,
      originalUrl: row.originalUrl || cached.originalUrl || '',
      croppedUrl: cached.croppedUrl,
      croppedDisplayUrl: cached.croppedDisplayUrl || cached.croppedUrl,
      status: cached.status || 'success',
      error: cached.error ?? row.error,
      cropPosition: cached.cropPosition ?? row.cropPosition,
      resultRevision: cached.resultRevision ?? row.resultRevision,
    };
  });
}
